export const GET_TICKET_TEAMS = 'GET_TICKET_TEAMS';
export const GET_TICKET_TEAMS_SUCCESS = 'GET_TICKET_TEAMS_SUCCESS';
export const GET_TICKET_TEAMS_FAIL = 'GET_TICKET_TEAMS_FAIL';
export const ADD_TICKET_TEAM_SUCCESS = 'ADD_TICKET_TEAM_SUCCESS';
export const UPDATE_TICKET_TEAM_SUCCESS = 'UPDATE_TICKET_TEAM_SUCCESS';
export const DELETE_TICKET_TEAM_SUCCESS = 'DELETE_TICKET_TEAM_SUCCESS';
export const SET_FETCHING_TICKET_TEAM = 'SET_FETCHING_TICKET_TEAM';